import script from "./Rate.vue?vue&type=script&setup=true&lang=js"
export * from "./Rate.vue?vue&type=script&setup=true&lang=js"

import "./Rate.vue?vue&type=style&index=0&id=431e3c66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-431e3c66"]])

export default __exports__